export default __webpack_public_path__ + "fonts/icon_calculator.svg";